import { apiGet } from "../utils/api";

class StreamStatsService {
  /**
   * Récupère le résumé des statistiques de stream (7 / 30 jours)
   * Prépare la future page \"Stats de Stream\".
   */
  async getStreamStats() {
    const endpoint = "/twitch/stream-stats";
    const response = await apiGet(endpoint);
    return response;
  }
}

const streamStatsService = new StreamStatsService();
export default streamStatsService;
